import { MapTo } from '@adobe/aem-react-editable-components';
import HeaderComponent, { HeaderComponentEditConfig } from './HeaderComponent';

export default MapTo('cob-corp-acquisition/components/creditonebank/header-component')(HeaderComponent, HeaderComponentEditConfig);